import { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import AppConfig from "../../../helpers/constants/AppConfig";
import MDBox from "../../MDs/MDBox";
import configs from "./configs";
import LoadingProgress from "../../LoadingProgress";

function PieChart({ chart }) {
  const { data, options } = configs(chart);

  return (
     <>
       {chart?.datasets ?
          <>
            {useMemo(
               () => (
                  <MDBox height={{ md: '285px', xs: '170px' }} mt={2} p={2}>
                    <Pie data={data} options={options} />
                  </MDBox>
               ),
               [data]
            )}
          </>
         :
          <LoadingProgress color={AppConfig.color} />
       }
     </>
  );
}

export default PieChart;
